var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as copy from 'copy-to-clipboard';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Icon, Snackbar, } from '@material-ui/core';
import { getTranslation } from 'src/translation';
import { connect } from 'react-redux';
var UnsupportedDialog = /** @class */ (function (_super) {
    __extends(UnsupportedDialog, _super);
    function UnsupportedDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            openSnackbar: false,
        };
        _this.copyStringToClipboard = function () {
            copy("" + window.location.origin + _this.props.url);
            _this.setState({ openSnackbar: true });
            setTimeout(function () { return _this.setState({ openSnackbar: false }); }, 2 * 1000);
        };
        return _this;
    }
    UnsupportedDialog.prototype.render = function () {
        var _a = this.props, open = _a.open, translate = _a.translate, url = _a.url, onClose = _a.onClose;
        var openSnackbar = this.state.openSnackbar;
        return (React.createElement(Dialog, { open: open, onClose: onClose },
            React.createElement(DialogTitle, null, translate('browser-not-supported')),
            React.createElement(DialogContent, null,
                React.createElement("div", null, translate('browser-not-supported-description-01')),
                React.createElement("br", null),
                React.createElement("div", null, translate('browser-not-supported-description-02')),
                React.createElement("br", null),
                React.createElement("div", null, translate('browser-not-supported-description-03')),
                React.createElement("br", null),
                React.createElement("div", null,
                    React.createElement("div", null, translate('video-link')),
                    React.createElement("div", { className: "flex items-center" },
                        React.createElement("span", { style: { width: 'calc(100% - 48px)' } },
                            window.location.origin,
                            url),
                        React.createElement(IconButton, { id: "file-copy-btn", onClick: this.copyStringToClipboard },
                            React.createElement(Icon, null, "file_copy")))),
                React.createElement("br", null),
                React.createElement("div", null, translate('browser-not-supported-description-04')),
                React.createElement("br", null),
                React.createElement("div", null, translate('browser-not-supported-description-05')),
                React.createElement(Snackbar, { open: openSnackbar, message: React.createElement("span", null, translate('copied-to-clipboard')) })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { name: "Cancel", id: "cancel-btn", onClick: onClose }, translate('cancel')))));
    };
    return UnsupportedDialog;
}(React.PureComponent));
var mapStateToProps = function (state) { return ({
    translate: getTranslation(state.translation.lang),
}); };
export default connect(mapStateToProps, null)(UnsupportedDialog);



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/UnsupportedDialog.tsx
// module id = 425
// module chunks = 81